"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrdersService = void 0;
const OpenAPI_1 = require("../core/OpenAPI");
const request_1 = require("../core/request");
class OrdersService {
    /**
     * @returns Order All orders for the logged in user
     * @throws ApiError
     */
    static getOrders() {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/orders',
            errors: {
                403: `Unauthorized`,
            },
        });
    }
    /**
     * @param orderId
     * @param preloadPaymentMethod
     * @returns InstallmentResult List of installments for the order
     * @throws ApiError
     */
    static getInstallments(orderId, preloadPaymentMethod) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/orders/{orderId}/installments',
            path: {
                'orderId': orderId,
            },
            query: {
                'preloadPaymentMethod': preloadPaymentMethod,
            },
            errors: {
                403: `Unauthorized`,
            },
        });
    }
}
exports.OrdersService = OrdersService;
